import React from 'react';
import classnames from 'classnames';

var styles = {"spinner":"uoU-LfjFDv0-","animationSpin":"_1aCKd5q9u34-","small":"cLRQwkSqnhA-","inline":"h6O4vDPCWOQ-"};

function Spinner({ size = "base", inline }) {
    const spinnerStyles = classnames(styles.spinner, {
        [styles.small]: size === "small",
        [styles.inline]: inline,
    });
    return (React.createElement("div", { className: spinnerStyles, role: "alert", "aria-busy": true, "aria-label": "loading" }));
}

export { Spinner as S };
